import { Component } from '@angular/core';
import { NavController, ModalController, App, MenuController } from 'ionic-angular';
import { ServicioProvider } from '../../providers/servicio/servicio';
import { ConfigProvider } from '../../providers/config/config';
import { NgxSpinnerService } from "ngx-spinner";
import { ApiClientError } from '../../models/api/api-envelope';
import { AuthProvider } from '../../providers/auth/auth';
import { LocationsProvider } from '../../providers/locations/locations';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  public user: string = "";
  public password: string = "";
  public code: string = "";
  btn_aceptar = "";

  fondo_login = "";
  linea_debajo_del_logo_fondo = "";
  lbl_titulos_color = "";
  btn_fondo = "";
  btn_color = "";

  btn_aceptar_color = "";
  color_border_input_user_user = "";
  color_border_input_user_pass = "";
  img_ancho = "";
  img_alto = "";
  tipo_spinner = "";

  constructor(public config: ConfigProvider, public navCtrl: NavController, public servicio: ServicioProvider, 
    public menuCtrl: MenuController, private modal_foto: ModalController, public spinner: NgxSpinnerService,
    public app: App, private auth: AuthProvider, private locations: LocationsProvider) {

  }
  ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }
  ionViewDidLoad() {

    this.tipo_spinner = this.config.tipo_spinner;
    this.img_ancho = this.config.img_ancho;
    this.img_alto = this.config.img_alto;
    this.btn_aceptar = this.config.btn_login_fondo;
    this.btn_aceptar_color = this.config.btn_login_fondo;

    this.fondo_login = this.config.fondo_login;
    this.linea_debajo_del_logo_fondo = this.config.linea_debajo_del_logo_fondo;
    this.lbl_titulos_color = this.config.lbl_titulos_color;
    this.btn_fondo = this.config.btn_login_fondo;
    this.btn_color = this.config.btn_login_color;
    this.color_border_input_user_user = this.config.color_border_input_user_user;
    this.color_border_input_user_pass = this.config.color_border_input_user_pass;

  }

  login() {

    if (this.user.trim().length == 0 && this.user.trim().length > 50 ||
      this.solo_letras(this.user.trim()) == false) {

      let modalFull = this.modal_foto.create("ModalInformativoPage",
        { "btn": "1", "btn_text_aceptar": "Aceptar", "btn_text_cancelar": "Cancelar", "ver_img_btn": "false", "msj": "Escribe un usuario válido" },
        //btn 1 = solo se ve btn aceptar //// btn 2 = se ven btns aceptar y cancelar  
        { cssClass: "class-modal-preview", enableBackdropDismiss: false })
      modalFull.onDidDismiss((dato) => {

      });
      modalFull.present();
      return;

    }
    else if (this.password.trim().length == 0 && this.password.trim().length > 50 ||
      this.solo_letras(this.password.trim()) == false) {

      let modalFull = this.modal_foto.create("ModalInformativoPage",
        { "btn": "1", "btn_text_aceptar": "Aceptar", "btn_text_cancelar": "Cancelar", "ver_img_btn": "false", "msj": "Escribe una contraseña válida" },
        { cssClass: "class-modal-preview", enableBackdropDismiss: false })
      modalFull.onDidDismiss((dato) => {

      });
      modalFull.present();
      return;
    }

    this.spinner.show();
    this.auth.login({ user: this.user.toString().trim(), password: this.password.toString().trim() })
      .then(session => this.locations.load(session.apiKey).then(locations => {
        this.servicio.save_locaciones(locations);
        this.servicio.save_apikey_login(session.apiKey);
        this.servicio.guardar_nombre_cliente(session.userName);

        // La primera locación sólo es el contexto inicial para pantallas que lo requieren
        // (por ejemplo Órdenes). El usuario ya no elige una durante el inicio de sesión.
        if (locations.length > 0) {
          locations[0].activo = "selected";
          this.locations.select(locations[0]);
          this.servicio.cambiar_Locacion(locations[0]);
        }
        else {
          this.locations.select(null);
          this.servicio.cambiar_Locacion(null);
        }
        this.app.getRootNav().setRoot("WelcomePage");
      }))
      .catch((error: ApiClientError) => {
        let message = "Sin conexión";
        if (error && error.kind === 'api') {
          message = "Usuario o contraseña incorrectos";
        }
        else if (error && (error.kind === 'locations' || error.kind === 'invalid-response')) {
          message = "No fue posible obtener las locaciones";
        }
        this.showControlledMessage(message);
      })
      .then(() => this.spinner.hide(), () => this.spinner.hide());
  }

  private showControlledMessage(message: string): void {
    const modal = this.modal_foto.create("ModalInformativoPage", {
      "btn": "1", "btn_text_aceptar": "Aceptar", "btn_text_cancelar": "Cancelar",
      "ver_img_btn": "false", "msj": message
    }, { cssClass: "class-modal-preview", enableBackdropDismiss: false });
    modal.present();
  }

  solo_letras(string) {
    var out = false;
    var filtro = ' abcdefghijklmnñopqrstuvwxyzABCDEFGHIJKLMNÑOPQRSTUVWXYZ1234567890';

    for (var i = 0; i < string.length; i++)
      if (filtro.indexOf(string.charAt(i)) != -1) {
        out = true;
      }
      else {

        out = false;
        break;
      }
    return out;
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts